import React from "react";

const ITEMS = [
  "Doctors & Clinics",
  "Dentists",
  "Dermatology",
  "Physiotherapy",
  "Salons",
  "Coaching",
  "Real Estate",
  "Diagnostic Labs",
  "Yoga Studios",
];

export default function TrustBar() {
  return (
    <section data-testid="trust-bar" className="border-y border-[var(--gf-border)] bg-white/60">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-6 flex flex-col md:flex-row md:items-center gap-4">
        <p className="text-xs uppercase tracking-[0.22em] font-semibold text-[var(--gf-blue)] whitespace-nowrap">
          Built for local growth
        </p>
        <div className="flex-1 overflow-hidden relative">
          <div className="flex gap-8 animate-[gfMarquee_30s_linear_infinite] whitespace-nowrap">
            {[...ITEMS, ...ITEMS].map((it, i) => (
              <span key={i} className="text-sm font-medium text-[var(--gf-text-2)]">
                {it} <span className="ml-8 text-[var(--gf-border)]">•</span>
              </span>
            ))}
          </div>
        </div>
      </div>

      <style>{`
        @keyframes gfMarquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
      `}</style>
    </section>
  );
}
